<template>
  <div class="margin-70">
    <BigTitle :bigtitle="bigtitle"></BigTitle>
    <dv-border-box-12 class="operaBox padding-sm margin-top-sm">
      <div
        class="operation flex align-center padding-tb-xs"
        v-for="(item,index) in overviewList"
        :key="index"
      >
        <div class="margin-left-sm margin-right-sm operateImg"><img
            class="operateIcon"
            :src="item.img"
          /></div>
        <div class="flex flex-direction">
          <p class="text-xsss">{{item.text}}</p>
          <div
            class="digitalFlop text-xxl-xl DS-font"
            :style="{'color':item.number.style.fill}"
          >{{item.number.content}}</div>
        </div>
      </div>
    </dv-border-box-12>
  </div>
</template>

<script>
import BigTitle from "@/components/bigTitle";
// 综合态势--动态渲染图片
import overview0 from "@/assets/images/index/overview1.png";
import overview1 from "@/assets/images/index/overview4.png";
import overview2 from "@/assets/images/index/overview2.png";
import overview3 from "@/assets/images/index/overview3.png";
import overview4 from "@/assets/images/index/overview3.png";

import { siteLeft } from "@/api/singleSite/left";
import { numChange } from '@/utils/index.js'
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data() {
    return {
      options: {},
      bigtitle: {
        CHN: "站点信息",
        ENG: "Overview",
      },
      overviewList: [
        {
          text: "排队数量",
          number: {
            content: "0",
            textAlign: "left",
            style: {
              fill: "#36FBFB",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview0,
        },
        {
          text: "配置电池数（块）",
          number: {
            content: "0",
            textAlign: "left",
            style: {
              fill: "#43FFB9",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview1,
        },
        {
          text: "换电价格（元）",
          number: {
            content: "0",
            textAlign: "left",
            style: {
              fill: "#FFFFFF",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview2,
        },
        {
          text: "累计换电次数（次）",
          number: {
            content: "0",
            textAlign: "left",
            style: {
              fill: "#179DFF",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview3,
        },
        {
          text: "累计收入（元）",
          number: {
            content: "0",
            textAlign: "left",
            style: {
              fill: "#36FBFB",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview4,
        },
      ],
    };
  },
  components: {
    BigTitle,
  },
  props: {
    // operList: {
    //   type: Object,
    //   default: () => ({})
    // },
  },
  watch: {},
  mounted() {
  },
  methods: {
    getData(data) {
      this.selectStationInfo(data);
    },
    //综合态势
    selectStationInfo(data = {}) {
      let _this = this;
      let params = {
					"enCode":"TiDB-zhandian-zhandianxinxi",//TiDB-站点-站点信息
          "@station_id":data.stationId
				}
        dataInterface
        .dataFaceApiXZ(params)
        .then((res) => {
          if (!res) return;
          res = res[0];
          _this. overviewList= [
        {
          text: "排队数量",
          number: {
            content: res.lineUpNum,
            textAlign: "left",
            style: {
              fill: "#36FBFB",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview0,
        },
        {
          text: "配置电池数（块）",
          number: {
            content: res.houseTotalBatteries,
            textAlign: "left",
            style: {
              fill: "#43FFB9",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview1,
        },
        {
          text: "换电价格（元）",
          number: {
            content: res.changePowerPrice,
            textAlign: "left",
            style: {
              fill: "#FFFFFF",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview2,
        },
        {
          text: "累计换电次数（次）",
          number: {
            content: res.PowerNum,
            textAlign: "left",
            style: {
              fill: "#179DFF",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview3,
        },
        {
          text: "累计收入（元）",
          number: {
            content: numChange(res.oper_income),
            textAlign: "left",
            style: {
              fill: "#36FBFB",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview4,
        },
        ];
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/overview.scss";
</style>